import { Observable } from "rxjs";

export abstract class OpenBrowserUrlRepo {
  /**
   * Opens a browser url and returns when browser is closed
   * @return If browser is closed
   */
  abstract open(url: string): Observable<boolean>;
}
